import { genComponentInstance } from '@/utils/utils';
import Placement from './index.vue';

/**
 * 设置设备地图坐标
 * @param {Object} data
 * @param {HTMLElement} data.container default:document.body 组件容器
 */
export function setDeviceCoordinate(data) {
  const instance = genComponentInstance(Placement, data);
  instance.$mount();
}
